import { kea } from 'kea'
import PropTypes from 'prop-types';
import { selector as configSelector, actions as configActions } from '~/config'

export default kea({
  path : () => ['root', 'index'],

  actions : ({ constants }) => ({
    loginSuccess: true,
    alreadyLoggedIn: true,
  }),

  reducers : ({ actions, constants }) => ({
    loggedIn: [false, PropTypes.bool, {
      [actions.loginSuccess]: () => true,
      [actions.alreadyLoggedIn]: () => true,
      [configActions.userLogout]: () => false,
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    contentVisible: [
      () => [
        configSelector,
        selectors.loggedIn
      ],
      (config, loggedIn) => {
        if(!loggedIn) {
          const { activePath } = config;
          return activePath === '/login/'
        }

        return true;
      },
      PropTypes.bool
    ]
  }),
})
